import React, { useCallback } from 'react'
import FormTile from 'src/components/common/containers/FormTile'
import InputTextField from 'src/components/common/form-elements/InputTextField'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useRewardsContext } from 'src/lib/contexts/RewardsConfigContext'
import { useRewardsPermissions } from 'src/lib/access-permission-hooks/useRewardsPermissions'

const CreditName = () => {
  const { t } = useLocale()
  const creditName = useRewardsContext(context => context.state?.creditName)
  const setCredit = useRewardsContext(context => context.actions?.setCreditName)

  const { canEditRewardsCustomisation } = useRewardsPermissions()

  const handleCreditNameChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, inputType: 'singularName' | 'pluralName') => {
      const enteredValue = event?.target?.value

      if (enteredValue?.length > 25) return
      setCredit({ ...creditName, [inputType]: enteredValue })
    },
    [creditName]
  )
  return (
    <FormTile title={'Name your credits'}>
      <div className='flex flex-row w-full  gap-5 '>
        <div className='flex flex-col w-full padding: 0px 16px 16px 16px cursor-pointer '>
          <h3 className='font-inter text-xs font-semibold leading-4 align-text-left'>{t('Singular')}</h3>
          <InputTextField
            isDisabled={!canEditRewardsCustomisation}
            inputValue={creditName?.singularName}
            textFieldId='singular-credit'
            handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCreditNameChange(event, 'singularName')}
            inputPlaceholder={t('store_credit')}
            inputType='text'
            isFullWidth={true}
            showCharacterCountConfig={{
              maxLength: 25,
              showOnlyOnFocus: true,
              customClass: 'text-xs font-normal text-gray-500 leading-tight'
            }}
          />
          <p className='font-inter text-xs font-normal leading-4 text-left'>{t('example_1_loyalty_coin')}</p>
        </div>
        <div className='flex flex-col w-full padding: 0px 16px 16px 16px cursor-pointer '>
          <h3 className='font-inter text-xs font-semibold leading-4 align-text-left'>{t('Plural')}</h3>
          <InputTextField
            isDisabled={!canEditRewardsCustomisation}
            inputValue={creditName?.pluralName}
            textFieldId='plural-credit'
            handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCreditNameChange(event, 'pluralName')}
            inputPlaceholder={t('store_credits')}
            inputProps={{ readOnly: false }}
            autoFocus={false}
            isFullWidth={true}
            showCharacterCountConfig={{
              maxLength: 25,
              showOnlyOnFocus: true,
              customClass: 'text-xs font-normal text-gray-500 leading-tight'
            }}
          />
          <p className='font-inter text-xs font-normal leading-4 text-left'>{t('example_2_loyalty_coins')}</p>
        </div>
      </div>
    </FormTile>
  )
}

export default React.memo(CreditName)
